import { render, staticRenderFns } from "./addDocument.vue?vue&type=template&id=60f81cf6&"
import script from "./addDocument.vue?vue&type=script&lang=js&"
export * from "./addDocument.vue?vue&type=script&lang=js&"
import style0 from "./addDocument.vue?vue&type=style&index=0&id=60f81cf6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports